/**
 * Single gate for the profile Work Insights section (and the future
 * plan-entitlement hook point — flip per plan when hiding/locking ships).
 */
export const WORK_INSIGHTS_ENABLED = true;

/**
 * Work habits and insights describe slow-moving traits, so profile analytics own a
 * fixed trailing window rather than following the profile page's date pickers.
 */
export const INSIGHTS_WINDOW_DAYS = 30;

/** Same 15-minute floor Productivity Trends uses for a meaningful active day. */
export const MEANINGFUL_ACTIVE_DAY_SEC = 15 * 60;

/** Relative to this employee's own median active day — not a company healthy band. */
export const SHORT_DAY_MEDIAN_RATIO = 0.6;
export const LONG_DAY_MEDIAN_RATIO = 1.4;
